import React from 'react';
import PropTypes from 'prop-types';
import './ToggleSwitch.scss';
import { useTranslation } from 'react-i18next';

const ToggleSwitch = ({ id, name, checked, onChange, small, disabled }) => {
  const { t, i18n } = useTranslation();

  function handleKeyPress(e) {
    if (e.keyCode !== 32) return;

    e.preventDefault();
    onChange(!checked);
  }

  return (
    <div className={'toggle-switch' + (small ? ' small-switch' : '')}>
      <input
        type="checkbox"
        name={name}
        className="toggle-switch-checkbox"
        id={id}
        value={checked}
        checked={checked}
        onChange={(e) => onChange(e.target.checked)}
        disabled={disabled}
      />
      {id ? (
        <label className="toggle-switch-label" tabIndex={disabled ? -1 : 1} onKeyDown={(e) => handleKeyPress(e)} htmlFor={id}>
          <span
            className={disabled ? 'toggle-switch-inner toggle-switch-disabled' : 'toggle-switch-inner'}
            data-yes={t('student.isActivated')}
            data-no={t('student.isNotActivated')}
            tabIndex={-1}
          />
          {/* This line to make the excel converter able to read the value of is Activated or not (ps: d-none means display: none) */}
          <span className="d-none">{checked ? t('student.isActivated') : t('student.isNotActivated')}</span>
          <span className={disabled ? 'toggle-switch-switch toggle-switch-disabled' : 'toggle-switch-switch'} tabIndex={-1} />
        </label>
      ) : null}
    </div>
  );
};

ToggleSwitch.propTypes = {
  id: PropTypes.string.isRequired,
  checked: PropTypes.bool.isRequired,
  onChange: PropTypes.func.isRequired,
  name: PropTypes.string,
  optionLabels: PropTypes.array,
  small: PropTypes.bool,
  disabled: PropTypes.bool,
};

export default ToggleSwitch;
